import { render, staticRenderFns } from "./classicCase.vue?vue&type=template&id=1ec12d64&"
import script from "./classicCase.vue?vue&type=script&lang=js&"
export * from "./classicCase.vue?vue&type=script&lang=js&"
import style0 from "./classicCase.vue?vue&type=style&index=0&id=1ec12d64&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports